/**
 * Created by stonewang on 2017/8/17.
 */
import React from 'react';
import Reflux from 'reflux';
import {Button, Icon, Popover, Menu, message} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, FilterBox, AdvanceFormNew} from 'Components';
import {sKeylist} from '../../service/dictionary/dataitem';
import {list, publishOrDown, setTop} from '../../service/channelFunc';
import {Store, Actions} from './store';

class ChannelFunceList extends React.Component {
    constructor(props) {
        super(props);
        this.store = Reflux.initStore(Store); //创建一个Store实例
        this.state = {
            filterBoxVisible: false,
            rows: [],
            total: 0,
            channel_information: [], //类型
            searchObj: {
                title: '',
                type: '',
                isPublish: '',
                startDate: '',
                endDate: '',
                s: 10,
                p: 1,
                source: '1'
            }
        };
        this.getData = this.getData.bind(this);
        this.pageChange = this.pageChange.bind(this);
        this.visibleChange = this.visibleChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.clickHandle = this.clickHandle.bind(this);
        this.takeBack = this.takeBack.bind(this);
        this.publish = this.publish.bind(this);
        this.comment = this.comment.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
    }

    routeLeaveHook(nextLocation) {
        let path = nextLocation.pathname.split('/');
        if (path[1] === 'channelFunc' && path[2] !== 'add') { //当下一个路由是详情页时，将useStore的值设为true
            Actions.useStoreChange(true);
            Actions.paramChange({...this.state.searchObj});
        } else {
            Actions.useStoreChange(false);
        }
    }

    componentWillMount() { //准备数据
        const self = this;
        const data = this.store.state;
        if (data.useStore) { //根据useStore的值判断是否使用store中的数据
            this.setState({
                ...this.state,
                searchObj: {
                    ...this.state.searchObj,
                    ...data.params,
                }
            });
        }
        sKeylist({sKey: 'channel_information'}).then(res => { //类型
            if (res.status) {
                let arr = [{value: '', text: '全部'}];
                res.data.forEach(x => {
                    arr.push({value: x.sKey, text: x.name});
                })
                let timer = window.setInterval(function () {
                    if (self.mounted) {
                        window.clearInterval(timer);
                        self.setState({channel_information: arr})
                    }
                }, 200);
            }
        })
    }

    componentDidMount() {
        this.mounted = true;
        this.getData();
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }

    getData() {
        const self = this;
        const {searchObj} = this.state;
        list(searchObj).then(res => {
            if (res.status) {
                self.setState({total: res.total, rows: res.data});
            } else {
                console.error(res.message);
            }
        });
    }

    goView(url) {
        hashHistory.push(url);
    }

    visibleChange() {
        this.setState({filterBoxVisible: !this.state.filterBoxVisible});
    }

    advanceReset() {
        const self = this;
        this.setState({
                filterBoxVisible: false,
                searchObj: {
                    ...this.state.searchObj,
                    title: '',
                    type: '',
                    isPublish: '',
                    isShow: '',
                    startDate: '',
                    endDate: '',
                    s: 10,
                    p: 1,
                }
            },
            function () {
                self.getData();
            })
    };

    advanceSubmit(form) {
        const self = this;
        this.setState({filterBoxVisible: false, searchObj: {...this.state.searchObj, p: 1}}, function () {
            self.getData();
        });
    };

    setFilterParam(name, value) {
        if (name === 'shipTime') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    startDate: value.from,
                    endDate: value.end
                }
            })
        } else {
            this.setState({searchObj: {...this.state.searchObj, [name]: value}})
        }
    };

    pageChange(page, pageSize) {
        const self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}}, function () {
            self.getData();
        });
    }

    clickHandle({item, key, keyPath}) {
        let str = key.split('_');
        this[str[0]](str[1]);
    }

    edit(id) {
        hashHistory.push(`/channelFunc/add/${id}`);
    }

    takeBack(id) {
        publishOrDown({ids: [id], status: 0}).then(res => {
            message[res.status ? 'success' : 'error'](res.message);
            res.status && this.getData();
        })
    }

    publish(id) {
        publishOrDown({ids: [id], status: 1}).then(res => {
            message[res.status ? 'success' : 'error'](res.message);
            res.status && this.getData();
        })
    }

    comment(id) {
        hashHistory.push(`/channelFunc/${id}/comment/list`);
    }

    setTop = (id) => { // 1置顶 0不置顶
        setTop({ids: [id], status: 1}).then(res => {
            message[res.status ? 'success' : 'error'](res.message);
            res.status && this.getData();
        });
    }
    cancelTop = (id) => {
        setTop({ids: [id], status: 0}).then(res => {
            message[res.status ? 'success' : 'error'](res.message);
            res.status && this.getData();
        });
    }

    createMenus(data) {
        const st = {margin: '-8px -16px'};
        return <Menu onClick={this.clickHandle} style={st}>
            <Menu.Item key={`edit_${data.id}`}>编辑</Menu.Item>
            {data.isPublish && <Menu.Item key={`takeBack_${data.id}`}>撤回</Menu.Item>}
            {!data.isPublish && <Menu.Item key={`publish_${data.id}`}>发布</Menu.Item>}
            {/*<Menu.Item key={`comment_${data.id}`}>查看评论</Menu.Item>*/}
            {data.isShow && data.isPublish && <Menu.Item key={`cancelTop_${data.id}`}>取消头条</Menu.Item>}
            {!data.isShow && data.isPublish && <Menu.Item key={`setTop_${data.id}`}>首页头条</Menu.Item>}
        </Menu>
    }

    render() {
        const {filterBoxVisible, rows, total, searchObj, channel_information} = this.state;
        const filterBoxProps = {
            showFlag: filterBoxVisible,
            advance: {
                fileds: [
                    {
                        name: 'title',
                        label: '主题',
                        text: '输入关键词',
                        defaultValue: searchObj.title,
                        type: 'default'
                    },
                    {
                        name: 'type',
                        label: '分类',
                        text: '选择分类',
                        defaultValue: searchObj.type,
                        options: channel_information,
                        multiple: false,//支持多选
                        type: 'select'
                    },
                    {
                        name: 'publishDate',//startLastOperationTime, endLastOperationTime
                        label: '发布时间',
                        options: [
                            {text: '开始时间'},
                            {text: '结束时间'}
                        ],
                        defaultValue: {
                            from: searchObj.startDate || '',
                            end: searchObj.endDate || ''
                        },
                        type: 'dateComp'
                    },
                    {
                        name: 'isPublish',
                        label: '状态',
                        text: '选择状态',
                        dataType: 'number',
                        defaultValue: searchObj.isPublish !== null ? searchObj.isPublish + '' : 'null',
                        options: [
                            {value: null, text: '全部'},
                            {value: 1, text: '已发布'},
                            {value: 0, text: '已撤回'},
                        ],
                        multiple: false,//支持多选
                        type: 'select'
                    }
                ],
                handle: this.advanceSubmit,
                reset: this.advanceReset,
                fieldHandle: this.setFilterParam
            }
        };
        const advanceProps = {
            fileds: [
                {
                    name: 'title',
                    label: '主题',
                    text: '输入主题',
                    type: 'default',
                    defaultValue: searchObj.title
                },
                {
                    name: 'shipTime',
                    label: '发布时间',
                    options: [
                        {text: '开始时间'},
                        {text: '结束时间'},
                    ],
                    type: 'dateComp',
                    defaultValue: {
                        from: searchObj.startDate || '',
                        end: searchObj.endDate || ''
                    }
                },
                {
                    name: 'isPublish',
                    label: '状态',
                    text: '选择状态',
                    options: [
                        {value: '', text: '所有'},
                        {value: '1', text: '已发布'},
                        {value: '0', text: '已撤回'}
                    ],
                    multiple: false,
                    type: 'select',
                    defaultValue: searchObj.isPublish
                },
                {
                    name: 'type',
                    label: '分类',
                    text: '选择分类',
                    options: [
                        {value: '', text: '所有'},
                        {value: '1', text: '政策公告'},
                        {value: '2', text: '产品公告'},
                        {value: '3', text: '促销公告'},
                        {value: '4', text: '其他公告'},
                        {value: '5', text: '新品发布'}
                    ],
                    multiple: false,
                    type: 'select',
                    defaultValue: searchObj.type
                }
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };
        const tableViewProps = {
            loading: false,
            rowKey: 'id',
            pageParam: {
                total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '主题',
                    dataIndex: 'title',
                    render: (text, record, index) => {
                        return <a href={`#/channelFunc/${record.id}`}>{text}</a>
                    }
                }, {
                    title: '分类',
                    dataIndex: 'typeText',
                }, {
                    title: '发布人',
                    dataIndex: 'userName'
                }, {
                    title: '发布时间',
                    dataIndex: 'publishDate',
                    render: (text) => text ? new Date(text).format('yyyy-MM-dd hh:mm') : ''
                }, {
                    title: '浏览/评论/转发',
                    dataIndex: 'commentCount',
                    render: (text, record, index) => {
                        return `${record.clickCount}/${record.commentCount}/${record.forwardCount}`
                    }
                }, {
                    title: '状态',
                    dataIndex: 'isPublish',
                    render: (text, record, index) => {
                        const menu = this.createMenus(record);
                        if (text === 1) {
                            return <span>
                已发布&nbsp;&nbsp;&nbsp;&nbsp;
                                <Popover placement="bottom" content={menu} trigger="click">
                  <Icon type="caret-down"/>
                </Popover>
              </span>
                        }
                        if (text === 0) {
                            return <span>
                已撤回&nbsp;&nbsp;&nbsp;&nbsp;
                                <Popover placement="bottom" content={menu} trigger="click">
                  <Icon type="caret-down"/>
                </Popover>
              </span>
                        }
                        return text;
                    }
                }
            ],
            rows
        };
        return <div className="dms-body">
            <DmsTab options={['资讯中心']} defaultKey={0}>
                <Button icon="plus" onClick={this.goView.bind(this, `/channelFunc/add/0`)}>新增</Button>
                {/*<Button icon="filter" onClick={this.visibleChange}>筛选</Button>*/}
                <FilterBox  {...filterBoxProps}/>
            </DmsTab>
            <div className="advanceForm-box">
                <div className="advanceForm-content">
                    <AdvanceFormNew {...advanceProps}/>
                </div>
            </div>
            <div className="dms-table-box">
                <TableView {...tableViewProps}/>
            </div>
        </div>
    }
}

export default withRouter(ChannelFunceList);


// WEBPACK FOOTER //
// ./src/routes/channelFunc/list.js